import React from "react";
import {CalendarEntry} from "../../../../../../api/grs";
import FormHeader from "../../../../../Form/FormHeader";
import {formatUnixToDDMMYYYYHHmm} from "../../../../../../utils/momentUtils";

export default function CalendarEntryAuthorInfo(props: CalendarEntry) {
    if (!props.authorName || !props.authorDate) return null;

    return (
        <>
            <FormHeader headerName="Event Author" />

            <div className="event-author-info">
                <div className="block">
                    <div className="label">Last Edited By:</div>
                    <div className="value">{props.authorName}</div>
                </div>

                <div className="block">
                    <div className="label">Last Edited Date:</div>
                    <div className="value">{formatUnixToDDMMYYYYHHmm(props.authorDate)}</div>
                </div>
            </div>
        </>
    );
}
